import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel, NameResponse} from '@common/models/commonHTTP.models';
import {
    BoardMeetingParticipantModel, BoardMeetingTotals,
    Meeting,
    MeetingAgendaItem, MeetingBoardParticipantsRequest,
    MeetingParticipantsRequest,
    MeetingPreparedItem,
    MeetingPreparedResponseTotal,
    MeetingStartedItem,
    ParticipantsSearchParams,
    VotingResultResponse
} from '@communication/_common/models/meeting.models';

export const SetInitialState = createAction(
    '[Meetings] Opened Item Set Initial State'
);

export const ClearEntities = createAction(
    '[Meetings] Clear Participants Items',
);

// <editor-fold desc="Meeting item - main">
export const GetMeetingItem = createAction(
    '[Meetings] Get Item',
    props<{ payload: Meeting }>()
);

export const GetMeetingItemSuccess = createAction(
    '[Meetings] Get Item Success',
    props<{ payload: Meeting }>()
);

// </editor-fold>

// <editor-fold desc="Meeting item - agenda">
export const LoadAgenda = createAction(
    '[Meetings] Load Agenda',
    props<{ payload: { meetingId: string, clearState?: boolean } }>()
);

export const LoadAgendaSuccess = createAction(
    '[Meetings] Load Agenda Success',
    props<{ payload: { items: MeetingAgendaItem[], clearState?: boolean } }>()
);

export const UpdateMeetingAgendaCount = createAction(
    '[Meetings] Update Meeting Agenda Count',
    props<{ payload: number }>()
);
// </editor-fold>


// <editor-fold desc="Meeting item - Participants Draft">
export const LoadParticipantsDraft = createAction(
    '[Meetings] Load Participants Draft',
    props<{ payload: { meetingId: string, loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadParticipantsDraftSuccess = createAction(
    '[Meetings] Load Participants Draft Success',
    props<{ payload: { items: MeetingPreparedItem[], totals: MeetingPreparedResponseTotal, pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadParticipantsDraftFailed = createAction(
    '[Meetings] Load Participants Draft Failed',
    props<{ payload: HttpErrorResponse }>()
);

export const SetParticipantsDraftPagination = createAction(
    '[Meetings] Set Participants Draft Pagination',
    props<{ payload: boolean }>()
);

export const SetParticipantsDraftFilter = createAction(
    '[Meetings] Set Participants Draft Filter',
    props<{ payload: ParticipantsSearchParams }>()
);

export const SetParticipantsDraftLoading = createAction(
    '[Meetings] Set Participants Draft Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetParticipantsDraftItemsLoading = createAction(
    '[Meetings] Set Participants Draft Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const AddParticipantDraftItems = createAction(
    '[Meetings] Add Participant Draft Items',
    props<{ payload: { meetingId: string, items: NameResponse[] } }>()
);

export const DeleteParticipantDraftItems = createAction(
    '[Meetings] Delete Participant Draft Items',
    props<{ payload: { meetingId: string, items: MeetingParticipantsRequest, reloadAll: boolean } }>()
);

export const DeleteParticipantDraftItemsSuccess = createAction(
    '[Meetings] Delete Participant Draft Item Success',
    props<{ payload: { items: string[], totals: MeetingPreparedResponseTotal } }>()
);

export const CheckAndUpdateParticipantDraftItem = createAction(
    '[Meetings] Check And Update Participant DraftItem',
    props<{ payload: { meetingId: string, itemId: string } }>()
);

export const UpdateParticipantDraftItemSuccess = createAction(
    '[Meetings] Update Participant Draft Item Success',
    props<{ payload: { meetingId: string, item?: MeetingPreparedItem, totals?: MeetingPreparedResponseTotal } }>()
);

// </editor-fold>

// <editor-fold desc="Meeting board item - Participants Draft">
export const LoadBoardParticipantsDraft = createAction(
    '[Meetings] Load Meeting Board Participants Draft',
    props<{ payload: { meetingId: string, loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadBoardParticipantsDraftSuccess = createAction(
    '[Meetings] Load Meeting Board Participants Draft Success',
    props<{ payload: { items: BoardMeetingParticipantModel[], totals: BoardMeetingTotals, pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadBoardParticipantsDraftFailed = createAction(
    '[Meetings] Load Meeting Board Participants Draft Failed',
    props<{ payload: HttpErrorResponse }>()
);

export const SetBoardParticipantsDraftPagination = createAction(
    '[Meetings] Set Meeting Board Participants Draft Pagination',
    props<{ payload: boolean }>()
);

export const SetBoardParticipantsDraftFilter = createAction(
    '[Meetings] Set Meeting Board Participants Draft Filter',
    props<{ payload: ParticipantsSearchParams }>()
);

export const SetBoardParticipantsDraftLoading = createAction(
    '[Meetings] Set Meeting Board Participants Draft Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetBoardParticipantsDraftItemsLoading = createAction(
    '[Meetings] Set Meeting Board Participants Draft Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const AddBoardParticipantDraftItems = createAction(
    '[Meetings] Add Meeting Board Participant Draft Items',
    props<{ payload: { meetingId: string, items: BoardMeetingParticipantModel[] } }>()
);

export const DeleteBoardParticipantDraftItems = createAction(
    '[Meetings] Delete Meeting Board Participant Draft Items',
    props<{ payload: { meetingId: string, items: MeetingBoardParticipantsRequest, reloadAll: boolean } }>()
);

export const DeleteBoardParticipantDraftItemsSuccess = createAction(
    '[Meetings] Delete Meeting Board Participant Draft Item Success',
    props<{ payload: { items: string[], totals?: BoardMeetingTotals } }>()
);

// export const CheckAndUpdateBoardParticipantDraftItem = createAction(
//     '[Meetings] Check And Update Meeting Board Participant DraftItem',
//     props<{ payload: { meetingId: string, itemId: string } }>()
// );

export const UpdateBoardParticipantDraftItemSuccess = createAction(
    '[Meetings] Update Meeting Board Participant Draft Item Success',
    props<{ payload: { meetingId: string, item: BoardMeetingParticipantModel } }>()
);

// </editor-fold>

// <editor-fold desc="Meeting item - Participants Started">
export const LoadParticipantsStarted = createAction(
    '[Meetings] Load Participants Started',
    props<{ payload: { meetingId: string, loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadParticipantsStartedSuccess = createAction(
    '[Meetings] Load Participants Started Success',
    props<{ payload: { items: MeetingStartedItem[], notifiable: boolean, pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadParticipantsStartedFailed = createAction(
    '[Meetings] Load Participants Started Failed',
    props<{ payload: HttpErrorResponse }>()
);

export const SetParticipantsStartedPagination = createAction(
    '[Meetings] Set Participants Started Pagination',
    props<{ payload: boolean }>()
);

export const SetParticipantsStartedFilter = createAction(
    '[Meetings] Set Participants Started Filter',
    props<{ payload: ParticipantsSearchParams }>()
);

export const SetParticipantsStartedLoading = createAction(
    '[Meetings] Set Participants Started Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetParticipantsStartedItemsLoading = createAction(
    '[Meetings] Set Participants Started Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const ClearParticipantsStartedItemsLoading = createAction(
    '[Meetings] Clear Participants Started Items Loading'
);

export const AddParticipantStartedItems = createAction(
    '[Meetings] Add Participant Started Items',
    props<{ payload: { meetingId: string, items: NameResponse[] } }>()
);

export const DeleteParticipantStartedItems = createAction(
    '[Meetings] Delete Participant Started Items',
    props<{ payload: { meetingId: string, items: MeetingParticipantsRequest, reloadAll: boolean } }>()
);

export const DeleteParticipantStartedItemsSuccess = createAction(
    '[Meetings] Delete Participant Started Item Success',
    props<{ payload: { items: string[], totals: MeetingPreparedResponseTotal } }>()
);

export const UpdateParticipantStartedItemSuccess = createAction(
    '[Meetings] Update Participant Started Item',
    props<{ payload: MeetingStartedItem }>()
);

export const ParticipantsStartedItemUpdatedWS = createAction(
    '[Meetings] Participants Started Item Updated WS',
    props<{ payload: string }>()
);


// </editor-fold>

// <editor-fold desc="Meeting item - results">
export const LoadResults = createAction(
    '[Meetings] Load Results',
    props<{ payload: string }>()
);

export const SetResultsForceUpdate = createAction(
    '[Meetings] Set Results Force Update'
);

export const LoadResultsSuccess = createAction(
    '[Meetings] Load Results Success',
    props<{ payload: VotingResultResponse }>()
);
// </editor-fold>
